import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ScheduleData from 'shared/data/Schedule';
import ListData from 'shared/data/List';
import { DisplayTypes } from 'shared/constants/FlowConstants';

let async = { asyncResult: true },
  ShowCSVFormActions = Reflux.createActions({
    submit: {},
    updateField: {},
    createFromCsv: async,
    populate: {},
    populateCSV: {},
    removeCSV: {},
    setActiveImportType: {},
    goToCSVMapping: {},
    addContributorColumnMap: {},
    mapColumn: {},
    mapDefaultValueForColumn: {},
    toggleColumnSkip: {},
    clear: {},
  });

ShowCSVFormActions.createFromCsv.listenAndPromise((teamId, eventId, csv) => {
  var handler = ShowData.createFromCsv;

  if (csv.type === DisplayTypes.schedule) handler = ScheduleData.createFromCsv;
  if (csv.type === DisplayTypes.list) handler = ListData.createFromCsv;

  return handler(teamId, eventId, csv);
});

export default ShowCSVFormActions;
